import { Radio, Space } from 'antd';
import { useEffect, useState } from 'react';

import { sort_list } from '../../Credit';
import styles from './CreditSortModal.module.css';

const CreditSortModal = ({ sort_visible, set_sort_visible, sort_value, set_sort_value }) => {
  const [current_item, set_current_item] = useState(1);

  useEffect(() => {
    if (sort_visible) {
      set_current_item(sort_value);
    }
    // eslint-disable-next-line
  }, [sort_visible]);

  const submit = () => {
    set_sort_value(current_item);
    set_sort_visible(false);
  };

  return (
    <>
      <Radio.Group onChange={(e) => set_current_item(e.target.value)} value={current_item}>
        <Space direction="vertical">
          {sort_list.map((item, i) => (
            <Radio key={i} value={item.value}>
              {item.label}
            </Radio>
          ))}
        </Space>
      </Radio.Group>
      <div className={styles.Seprator} />
      <button className={styles.SubmitButton} onClick={submit} type="button">
        اعمال
      </button>
    </>
  );
};

export default CreditSortModal;
